import { Geometry } from '@turf/turf';
import { MapStyle } from '../../shared/models/map-configuration';
import { PaddingOptions } from 'mapbox-gl';

export enum MAP_STATE {
    VIEW = 'view',
    EDIT_FEATURE = 'edit_feature',
    CREATE_FEATURE = 'create_feature',
    EDIT_DRAW_ALTERNATE_ROUTE = 'edit_draw_alternate_route',
    EDIT_SELECT_ALTERNATE_ROUTE = 'edit_select_alternate_route'
}

export class MapState {
    loaded: boolean;
    center: [number, number];
    pitch: number;
    bearing: number;
    zoom: number;
    style: MapStyle; // the style on the map
    dragging: boolean;
    padding: PaddingOptions;

    bounds: number[][];
    bbox: Geometry;
    itemsClicked: {
        id: any;
        type: string;
    }[];

    clickedCoordinate: {
        lng: number; lat: number;
    };

    rightClicked: {
        lng: number;
        lat: number;
        x: number;
        y: number;
    }

    leftClicked:{}

    state: MAP_STATE;

    constructor() {
        this.loaded = false;
    }
}
